import React from "react";
import Header from "../Header";
import "./index.css";

const About = () => {
  return (
    <div className="about-main-container">
      <Header />
      <div className="about-container" >
        <img className="under-development-img" src="https://res.cloudinary.com/dbsdzzvez/image/upload/v1720705365/BookHub/mlwy1orcdzf5kam0u2sq.jpg" alt="under png" />
        <p className="under-development-text">Under Development</p>
      </div>
    </div>
  );
};

export default About;
